export const SET_LOBBY_BANNER = 'LOBBYBANNER/SET_LOBBY_BANNER'
export const SET_LOBBY_BANNERS = 'LOBBYBANNER/SET_LOBBY_BANNERS'
